import { useState } from 'react';
import {
  InformationCircleIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon
} from '@heroicons/react/24/outline';

const Alert = ({ type = 'info', message, onClose, className = '' }) => {
  const [isExiting, setIsExiting] = useState(false);

  const typeClasses = {
    info: 'bg-blue-50 border border-blue-200 text-blue-800',
    success: 'bg-green-50 border border-green-200 text-green-800',
    warning: 'bg-amber-50 border border-amber-200 text-amber-800',
    error: 'bg-red-50 border border-red-200 text-red-700'
  };

  const typeConfig = {
    info: {
      icon: InformationCircleIcon,
      iconColor: 'text-blue-500'
    },
    success: {
      icon: CheckCircleIcon,
      iconColor: 'text-green-500'
    },
    warning: {
      icon: ExclamationTriangleIcon,
      iconColor: 'text-amber-500'
    },
    error: {
      icon: ExclamationCircleIcon,
      iconColor: 'text-red-400'
    }
  };

  const config = typeConfig[type];
  const IconComponent = config.icon;

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  return (
    <div className={`
      ${typeClasses[type]} ${className}
      rounded-lg p-4
      transition-all duration-300 ease-out overflow-hidden
      ${isExiting
        ? 'max-h-0 opacity-0 scale-y-0 mb-0'
        : 'max-h-20 opacity-100 scale-y-100 mb-6'
      }
    `}>
      <div className="flex items-center flex-1">
        <IconComponent className={`w-6 h-6 mr-3 ${config.iconColor}`} />
        <span className="text-sm">{message}</span>
      </div>
      {onClose && (
        <button
          className="ml-3 opacity-50 hover:opacity-100 transition-opacity"
          onClick={handleClose}
          title="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
  );
};

export default Alert;